import {notification} from "../helpers/notification";

$(document).ready(function() {
    $('.js-hamburger-reciever').on('click', function () {
        if($(this).is(':checked')) {
            $('.dropdown-menu').slideDown();
            $('body').addClass('no-scroll');
        }else {
            $('.dropdown-menu').slideUp();
            $('body').removeClass('no-scroll');
        }
    });
})
